import http from "@/shared/services/http";

export const createSale = (data: any) => http.post(`v1/sales`, data);
export const singleSale = (id: any) => http.get(`v1/sales/${id}`);
export const updateSale = (id: any, data: any) => http.put(`v1/sales/${id}`, data);
export const deleteSale = (id: any) => http.delete(`v1/sales/${id}`);
export const listSale = (params: any) => http.get(`v1/sales`, { params });
